// Add this to your theme.liquid file or as a separate JS file
class CartDrawerController {
  constructor() {
    this.isInitialized = false;
    this.init();
  }

  init() {
    // Don't initialize multiple times
    if (this.isInitialized) return;
    this.isInitialized = true;

    // Set up click listener for cart trigger
    this.cartTrigger = document.querySelector('.js-cart-trigger');
    if (this.cartTrigger) {
      this.cartTrigger.addEventListener('click', this.handleCartTriggerClick.bind(this));
    }

    // Set up listeners for add to cart buttons
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Wait for the cart to update before trying to open drawer
        setTimeout(() => {
          this.openCartDrawer();
        }, 600);
      });
    });

    // Listen for cart drawer events
    document.addEventListener('cart:refresh', () => {
      setTimeout(() => {
        // Try to highlight new items
        this.checkForNewItems();
      }, 500);
    });

    // Listen for cart drawer close
    const cartDrawerOverlay = document.querySelector('#CartDrawer-Overlay');
    if (cartDrawerOverlay) {
      cartDrawerOverlay.addEventListener('click', this.closeCartDrawer.bind(this));
    }

    // Make methods globally available
    window.openCartDrawer = this.openCartDrawer.bind(this);
    window.closeCartDrawer = this.closeCartDrawer.bind(this);
  }

  handleCartTriggerClick(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('Cart trigger clicked');
    this.openCartDrawer();
  }

  openCartDrawer() {
    console.log('Attempting to open cart drawer');

    // Get all possible cart drawer elements 
    const cartDrawerElement = document.querySelector('cart-drawer');
    const cartDrawerById = document.querySelector('#CartDrawer');

    // Method 1: Use cart-drawer custom element if it exists
    if (cartDrawerElement) {
      console.log('Found cart-drawer element, attempting to open');
      
      // Try using open() method if available
      if (typeof cartDrawerElement.open === 'function') {
        console.log('Using open() method');
        cartDrawerElement.open();
        return true;
      }
      
      // If no open method, try setting the open attribute and classes
      console.log('Setting open attribute and classes');
      cartDrawerElement.setAttribute('open', '');
      cartDrawerElement.classList.add('active', 'is-open');
      
      // Force display
      cartDrawerElement.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      return true;
    }
    
    // Method 2: Try direct #CartDrawer element
    if (cartDrawerById) {
      console.log('Using #CartDrawer element');
      cartDrawerById.classList.add('active');
      
      // Try to activate overlay
      const overlay = document.querySelector('.cart-drawer__overlay, #CartDrawer-Overlay');
      if (overlay) {
        overlay.classList.add('active');
      }
      
      document.body.style.overflow = 'hidden';
      return true;
    }

    // Method 3: Try .cart-drawer class
    const cartDrawerByClass = document.querySelector('.cart-drawer');
    if (cartDrawerByClass) {
      console.log('Using .cart-drawer element');
      cartDrawerByClass.classList.add('active');
      cartDrawerByClass.style.transform = 'translateX(0)';
      document.body.style.overflow = 'hidden';
      return true;
    }

    // Method 4: Try data-section-type or data attributes approach
    const drawerByAttribute = document.querySelector('[data-section-type="cart-drawer"], [data-drawer="cart"]');
    if (drawerByAttribute) {
      console.log('Using drawer by data attribute');
      drawerByAttribute.classList.add('active');
      document.body.classList.add('js-drawer-open');
      return true;
    }

    // Method 5: Dispatch events that the theme might be listening for
    console.log('Dispatching custom events');
    this.dispatchCartEvents();

    // Method 6: Last resort - refresh the cart using AJAX
    this.refreshCartAjax();
    
    return false;
  }

  closeCartDrawer() {
    const cartDrawerElement = document.querySelector('cart-drawer');
    const cartDrawerById = document.querySelector('#CartDrawer');
    
    if (cartDrawerElement && typeof cartDrawerElement.close === 'function') {
      cartDrawerElement.close();
      return;
    }
    
    if (cartDrawerElement) {
      cartDrawerElement.removeAttribute('open');
      cartDrawerElement.classList.remove('active', 'is-open');
    }
    
    if (cartDrawerById) {
      cartDrawerById.classList.remove('active');
    }
    
    document.body.style.overflow = '';
    
    // Get and deactivate overlay
    const overlay = document.querySelector('.cart-drawer__overlay, #CartDrawer-Overlay');
    if (overlay) {
      overlay.classList.remove('active');
    }
  }

  dispatchCartEvents() {
    // Try all common event names used by Shopify themes
    const events = [
      'cart:open',
      'theme:cart:open',
      'drawer:open',
      'cart.requestStarted',
      'cart:toggle'
    ];
    
    events.forEach(eventName => {
      document.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail: { drawer: 'cart' }
      }));
    });
  }

  refreshCartAjax() {
    console.log('Trying AJAX cart refresh');
    
    if (window.fetch) {
      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Cart data refreshed');
        
        // Dispatch update events
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
        
        // Try one more time to open drawer
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
          if (cartDrawer) {
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              cartDrawer.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          }
        }, 300);
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
    }
  }

  checkForNewItems() {
    const cartItems = document.querySelectorAll('.cart-item');
    if (!cartItems.length) return;
    
    // Get current items for comparison
    const currentItems = Array.from(cartItems).map(item => {
      return {
        productId: item.getAttribute('data-product-id'),
        variantId: item.getAttribute('data-variant-id'),
        element: item
      };
    });
    
    // If we don't have previous items stored, just store these
    if (!this.previousCartItems) {
      this.previousCartItems = currentItems.map(item => ({
        productId: item.productId,
        variantId: item.variantId
      }));
      return;
    }
    
    // Find new items
    currentItems.forEach(newItem => {
      const existingItem = this.previousCartItems.find(item => 
        item.productId === newItem.productId && 
        item.variantId === newItem.variantId
      );
      
      if (!existingItem) {
        // This is a new item - highlight it
        newItem.element.classList.add('cart-item--new');
        
        // Remove highlight class after animation completes
        setTimeout(() => {
          newItem.element.classList.remove('cart-item--new');
        }, 2000);
      }
    });
    
    // Update stored items
    this.previousCartItems = currentItems.map(item => ({
      productId: item.productId,
      variantId: item.variantId
    }));
  }
}

// Initialize cart drawer controller when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Create cart drawer controller
  window.cartDrawerController = new CartDrawerController();
});